export default "__VITE_ASSET__AOilhV6e__"